import React from 'react';
import {
    TextField,
} from '@shopify/polaris';

export function RuleNameFormElement(props) {

    return (
        <TextField
            label="Rule Name"
            placeholder="Rule name"
            helpText={
                <span>
                    Give a name to easily identify this custom product rule.
                </span>
            }
            value={props.rule.name}
            error={props.ruleErrors["name"]}
            onChange={(newValue) => props.onFieldValueChange("name", newValue)}
            autoComplete="off"
        />
    );
}